import FdeskFormHandlers from './fdesk-form-handlers';
import FcallerFormHandlers from './fcaller-form-handlers';
import GenericFormHandlers from './miscellaneous-form-handlers';
import FserviceFormHandlers from './fservice-form-handlers';
import MtgapFormHandlers from './mtgap-form-handlers';
import FthoughtsFormHandlers from './fthoughts-form-handlers';
import FsalesFormHandlers from './fsales-form-handlers';
import FreleaseFormHandlers from './frelease-form-handlers';
import FteamFormHandlers from './fteam-form-handlers';
import FmarketerFormHandlers from './fmarketer-form-handlers';
import FchatFormHandlers from './fchat-form-handlers';
import FstatusFormHandlers from './fstatus-form-handlers';
import FpingFormHandlers from './fping-form-handlers';
import FconnectFormHandlers from './fconnect-form-handlers';
import AlohaFormHandlers from './aloha-form-handlers';
import SubmitHelpers from './submit-helpers';
import C4lSubscribeForm from './c4l-form-handlers';
import FreddyFormHandlers from './freddy-form-handlers';
import FwcrmFormHandlers from './fwcrm-form-handlers';
import FsurveyFormHandlers from './fsurvey-form-handlers';
import FwcssuiteFormHandlers from './fwcssuite-form-handlers';

const {
  fdeskForm,
  fdeskSignupForm,
  fdeskLoginForm,
  fdeskForgotDomainForm,
  fdeskDemoRequestForm,
  fdeskAcademyCoursesForm,
  fdeskTryWithoutSignupForm,
  fdeskFeaturesListForm,
  fdeskGartnerMagicQuadrantForm,
  fdeskCaseStudyForm,
  fdeskEmailOnlySignupForm
} = FdeskFormHandlers;

const {
  fserviceSignupForm,
  fserviceLoginForm,
  fserviceForgotDomainForm,
  fserviceDemoRequestForm,
  fserviceEmailOnlySignupForm
} = FserviceFormHandlers;

const {
  fcallerSignupForm,
  fcallerLoginForm,
  fcallerForgotDomainForm
} = FcallerFormHandlers;

const {
  animateFormWrapper,
  contactForm,
  roiForm,
  roiDetailedReportForm,
  webinarSubscribeForm,
  unsubscribe,
  emailOnlySubscription,
  gdprSubscriptionToggleForm,
  whitepaperForm,
  jobDescriptionForm,
  partnerResellerSignupForm,
  createSupportTicket,
  affiliateForm,
  expressCheckoutForm,
  academyForm,
  accessSecurityResourcesForm,
  bugReportForm,
  genericForm,
  waitlistForm,
  sysadminForm,
  forrestFormHandler,
  wheelSpinnerForm,
  createFdeskSupportTicket
} = GenericFormHandlers;

const {
  mtgapSubscribeForm
} = MtgapFormHandlers;

const {
  fthoughtsSubscribeForm
} = FthoughtsFormHandlers;

const {
  fsalesForm
} = FsalesFormHandlers;

const {
  freleaseSignupForm
} = FreleaseFormHandlers;

const {
  fteamSignupForm,
  fteamLoginForm,
  fteamDemoRequestForm,
  fteamForgotDomainForm,
  fteamEmailMeForm
} = FteamFormHandlers;

const {
  fmarketerSignupForm,
  fmarketerLoginForm,
  fmarketerForgotDomainForm,
  fmarketerDemoRequestForm,
  fmarketerTemplateSelectionForm
} = FmarketerFormHandlers;

const {
  fchatSignupForm,
  fchatDemoRequestForm,
  fchatWhatsappHandler,
  fchatLoginForm,
  fchatForgotDomainForm
} = FchatFormHandlers;

const {
  fstatusSignupForm,
  fstatusLoginForm,
  fstatusForgotDomainForm
} = FstatusFormHandlers;

const {
  fpingSignupForm,
  fpingLoginForm,
  fpingForgotDomainForm
} = FpingFormHandlers;

const {
  fconnectSignupform,
  fconnectLoginForm,
  fconnectForgotDomainForm
} = FconnectFormHandlers;

const {
  alohaForm
} = AlohaFormHandlers;

const {
  fwcrmLoginForm,
  fwcrmForgotDomainForm
} = FwcrmFormHandlers;

const {
  c4lSubscribeForm
} = C4lSubscribeForm;

const {
  freddySignupForm
} = FreddyFormHandlers;

const {
  fsurveyLoginForm,
  fsurveyForgotDomainForm
} = FsurveyFormHandlers;

const {
  fwcssuiteSignupFormSuccess,
  fwcssuiteLoginForm,
  fwcssuiteForgotDomainForm
} = FwcssuiteFormHandlers;

const submit = {
  fdeskForm,
  fdeskSignupForm,
  fdeskLoginForm,
  fdeskForgotDomainForm,
  fdeskDemoRequestForm,
  fdeskAcademyCoursesForm,
  fdeskTryWithoutSignupForm,
  fdeskFeaturesListForm,
  fdeskGartnerMagicQuadrantForm,
  fdeskCaseStudyForm,
  fdeskEmailOnlySignupForm,
  fcallerSignupForm,
  fcallerLoginForm,
  fcallerForgotDomainForm,
  animateFormWrapper,
  contactForm,
  roiForm,
  roiDetailedReportForm,
  webinarSubscribeForm,
  unsubscribe,
  emailOnlySubscription,
  gdprSubscriptionToggleForm,
  whitepaperForm,
  jobDescriptionForm,
  partnerResellerSignupForm,
  createSupportTicket,
  affiliateForm,
  expressCheckoutForm,
  academyForm,
  accessSecurityResourcesForm,
  bugReportForm,
  genericForm,
  waitlistForm,
  forrestFormHandler,
  fserviceSignupForm,
  fserviceLoginForm,
  fserviceForgotDomainForm,
  fserviceDemoRequestForm,
  fserviceEmailOnlySignupForm,
  mtgapSubscribeForm,
  fthoughtsSubscribeForm,
  fsalesForm,
  freleaseSignupForm,
  fteamSignupForm,
  fteamLoginForm,
  fteamDemoRequestForm,
  fteamForgotDomainForm,
  fteamEmailMeForm,
  fmarketerSignupForm,
  fmarketerLoginForm,
  fmarketerForgotDomainForm,
  fmarketerDemoRequestForm,
  fmarketerTemplateSelectionForm,
  fchatSignupForm,
  fchatDemoRequestForm,
  fchatWhatsappHandler,
  fchatLoginForm,
  fchatForgotDomainForm,
  fstatusSignupForm,
  fstatusLoginForm,
  fstatusForgotDomainForm,
  fpingSignupForm,
  fpingLoginForm,
  fpingForgotDomainForm,
  fconnectSignupform,
  fconnectLoginForm,
  fconnectForgotDomainForm,
  sysadminForm,
  alohaForm,
  c4lSubscribeForm,
  freddySignupForm,
  fwcrmLoginForm,
  fwcrmForgotDomainForm,
  wheelSpinnerForm,
  createFdeskSupportTicket,
  fsurveyLoginForm,
  fsurveyForgotDomainForm,
  fwcssuiteSignupFormSuccess,
  fwcssuiteLoginForm,
  fwcssuiteForgotDomainForm
};

var fnExport = SubmitHelpers.encapsulateLocation(submit);
export default fnExport;
